import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "src/components/Shared/NewForms/NFLookupDivision";
import { NFLookupInput } from "src/components/Shared/NewForms/NFLookupInput";
import { EnumHelper } from "src/components/../helpers/EnumHelper";
import { useTranslation } from "react-i18next";
import { NFLookupUser } from "src/components/Shared/NewForms/NFLookupUser";
import { useFormContext } from "react-hook-form";

export const DistributionOfLandedCostsDetailMain = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Document#")} disabled fieldName={"documentNumber"} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} required={true} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany fieldName={"companyId"} title={t("Company")} required={true} />
        </Col>
        <Col sm={6}>
          <NFLookupDivision
            fieldName={"divisionId"}
            title={t("Division")}
            // companyId={watch("companyId")}
            // required={true}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          {/*<NFLookupUser*/}
          {/*    fieldName={"approvedById"}*/}
          {/*    title={t("ApprovedById")}*/}
          {/*    required={true}*/}
          {/*/>*/}
        </Col>
        <Col sm={6}>
          <NFLookupInput title={t("DistributionMethod")} fieldName={"distributionMethod"} items={EnumHelper.getDistributionLandedCostsMethodEnum(t)} />
        </Col>
      </Row>
    </>
  );
};
